import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectGeolocationStatus } from '../../../store/geolocation/geolocation.selectors'
import { setGeolocationStatus } from '../../../store/geolocation/geolocationSlice'
import {
  GEOLOC_STATUS_BLOCKED,
  GEOLOC_STATUS_BUTTON_WORKFLOW,
  GEOLOC_STATUS_DISABLED,
  GEOLOC_STATUS_FETCH_ACTIVE,
  GEOLOC_STATUS_FETCH_FOLLOW,
  GEOLOC_STATUS_FOLLOW
} from '../../../store/map/map.constants'
import { selectShouldDisplayMapTools } from '../../../store/ui/ui.selectors'
import mappyLogoFilled from '../../genericComponents/assets/mappy-logo-filled.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import s from './GeolocButton.less'
import useTooltip from './useTooltip'
import useDynamicButtons, { GEOLOC_BUTTON_TYPE } from '../common/useDynamicButtons'
import { selectIsMapFullScreen } from '../../../store/map/map.selectors'

const GeolocButton = () => {
  const dispatch = useDispatch()
  const isMapFullscreen = useSelector(selectIsMapFullScreen)
  const { getButtonStyle } = useDynamicButtons({ buttonType: GEOLOC_BUTTON_TYPE })
  const status = useSelector(selectGeolocationStatus)
  const [statusFromButton, setStatusFromButton] = useState(null)
  const isFollowStatus = status === GEOLOC_STATUS_FOLLOW
  const isBlockStatus = status === GEOLOC_STATUS_BLOCKED
  const isFetchStatus = status === GEOLOC_STATUS_FETCH_ACTIVE || status === GEOLOC_STATUS_FETCH_FOLLOW

  const { tooltip, mouseListeners } = useTooltip({ ge: true, pe: isBlockStatus })

  useEffect(() => {
    if (statusFromButton && status !== statusFromButton) {
      setStatusFromButton(null)
    }
  }, [status, statusFromButton])

  const onClick = () => {
    const newStatus = GEOLOC_STATUS_BUTTON_WORKFLOW[status]
    if (newStatus !== GEOLOC_STATUS_DISABLED) {
      setStatusFromButton(newStatus)
      dispatch(setGeolocationStatus(newStatus, { mapMove: true }))
    } else {
      dispatch(setGeolocationStatus(newStatus))
    }
  }

  return (
    <span
      className={s.geoloc}
      onClick={onClick}
      {...mouseListeners}
      style={isMapFullscreen ? undefined : getButtonStyle()}
    >
      <div className={classNames(s.button, isFollowStatus ? s.follow : s.active)}>
        <div className={classNames('icon', s.icon)}>
          <div className={classNames(s.icon, isFetchStatus && s.fetch)}>
            <SVGIcon url={mappyLogoFilled} />
          </div>
        </div>
      </div>
      <span className={classNames(s.tooltip, tooltip && 'active', isBlockStatus && s.error)}>
        {isBlockStatus ? <T id={'geolocation.error'} /> : <T id={'map.tools.geoloc.tooltip'} />}
      </span>
    </span>
  )
}

export default withEverySelectorTruthy(selectShouldDisplayMapTools)(GeolocButton)
